import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8790597e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ui-card" }
const _hoisted_4 = { class: "ui-card-body" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-3" }
const _hoisted_7 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_8 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-lg-2 ant-col-xl-2" }
const _hoisted_10 = {
  key: 0,
  class: "upload-imagem-overlay"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-imagem-texto" }, "Enviando imagem...", -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "upload-imagem-overlay" }
const _hoisted_14 = { class: "upload-imagem-acoes" }
const _hoisted_15 = { class: "upload-imagem-vazio" }
const _hoisted_16 = { class: "upload-imagem-icone" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-lg-9 ant-col-xl-9" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-lg-3 ant-col-xl-3" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-14" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-10" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-18" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_tipo_documento = _resolveComponent("combo-tipo-documento")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_card = _resolveComponent("card")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.state.computedVisivel,
    "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.computedVisivel) = $event)),
    width: 1200,
    centered: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Cadastro de Segurado ")
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "ui-button -primary",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.appBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: _ctx.appBase.carregando
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_spin, {
                        tip: "Consultando CNPJ...",
                        spinning: _ctx.consultandoDocumento
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card, { titulo: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_a_form_item, { label: "Documento" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_combo_tipo_documento, {
                                        valor: _ctx.state.segurado.tipoDocumento,
                                        "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.segurado.tipoDocumento) = $event))
                                      }, null, 8, ["valor"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                (_ctx.state.segurado.tipoDocumento === _ctx.ETipoDocumento.CPF)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _createVNode(_component_a_form_item, { label: "Número" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_cpf, {
                                            valor: _ctx.state.segurado.numeroDocumento,
                                            "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.segurado.numeroDocumento) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.segurado.tipoDocumento === _ctx.ETipoDocumento.CNPJ)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createVNode(_component_a_form_item, { label: "Número" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_cnpj, {
                                            valor: _ctx.state.segurado.numeroDocumento,
                                            "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.segurado.numeroDocumento) = $event)),
                                            onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.consultaDocumento()))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.state.segurado.tipoDocumento === _ctx.ETipoDocumento.CPF?'ant-col ant-col-xs-24 ant-col-lg-13 ant-col-xl-13':'ant-col ant-col-xs-24 ant-col-lg-13 ant-col-xl-13')
                                }, [
                                  _createVNode(_component_a_form_item, {
                                    label: _ctx.state.segurado.tipoDocumento === _ctx.ETipoDocumento.CPF?'Nome':'Razão Social/Nome da Empresa'
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.segurado.nomeRazaoSocial) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.segurado.nomeRazaoSocial]
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ], 2),
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_a_form_item, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["upload-imagem", {
                                  '-has-image': _ctx.possuiImagem,
                                  '-uploading': _ctx.state.enviandoImagem,
                                  '-dragover': _ctx.state.dragOverImagem,
                                }]),
                                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args))),
                                        onDragover: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.state.dragOverImagem = true), ["prevent"])),
                                        onDragleave: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.state.dragOverImagem = false), ["prevent"])),
                                        onDrop: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropArquivo && _ctx.dropArquivo(...args)), ["prevent"]))
                                      }, [
                                        _createElementVNode("input", {
                                          id: "selecionarArquivo",
                                          type: "file",
                                          accept: ".png,.jpg,.jpeg,.webp",
                                          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.enviarArquivos && _ctx.enviarArquivos(...args))),
                                          style: {"display":"none"}
                                        }, null, 32),
                                        (_ctx.state.enviandoImagem)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                              _createVNode(_component_a_spin, { size: "large" }),
                                              _hoisted_11
                                            ]))
                                          : (_ctx.possuiImagem)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("img", {
                                                  src: _ctx.state.segurado.imagem,
                                                  alt: "Imagem do segurado",
                                                  class: "upload-imagem-preview"
                                                }, null, 8, _hoisted_12),
                                                _createElementVNode("div", _hoisted_13, [
                                                  _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      class: "upload-imagem-acao",
                                                      onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selecionarArquivoUpload && _ctx.selecionarArquivoUpload(...args)), ["stop"]))
                                                    }, " Trocar "),
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      class: "upload-imagem-acao -danger",
                                                      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removerImagem && _ctx.removerImagem(...args)), ["stop"]))
                                                    }, " Remover ")
                                                  ])
                                                ])
                                              ], 64))
                                            : (_openBlock(), _createBlock(_component_a_tooltip, {
                                                key: 2,
                                                title: "Clique ou arraste uma imagem aqui nos formatos:  PNG, JPG, JPEG ou WEBP"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("div", _hoisted_16, [
                                                      _createVNode(_component_icone, {
                                                        nome: "camera",
                                                        style: {"font-size":"28px"}
                                                      })
                                                    ])
                                                  ])
                                                ]),
                                                _: 1
                                              }))
                                      ], 34)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_a_form_item, { label: "Website" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.segurado.site) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.segurado.site]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_a_form_item, { label: "IE" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.segurado.inscricaoEstadual) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.segurado.inscricaoEstadual]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_a_form_item, { label: "Ramo de Atividade" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.segurado.ramoAtividade) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.segurado.ramoAtividade]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_a_form_item, { label: "Ativo" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_selecionar_sim_nao, {
                                        "radio-button": true,
                                        valor: _ctx.state.segurado.status,
                                        "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.segurado.status) = $event))
                                      }, null, 8, ["valor"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          ((_ctx.state.apresentarCampos))
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 0,
                                titulo: "CONTATO NA EMPRESA"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_a_form_item, { label: "Nome" }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.segurado.contatoNome) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.state.segurado.contatoNome]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_component_a_form_item, { label: "Cargo" }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.segurado.contatoCargo) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.state.segurado.contatoCargo]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createVNode(_component_a_form_item, { label: "Telefone" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_telefone, {
                                            valor: _ctx.state.segurado.contatoFone,
                                            "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.segurado.contatoFone) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                      _createVNode(_component_a_form_item, { label: "E-mail" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_email, {
                                            valor: _ctx.state.segurado.contatoEmail,
                                            "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.segurado.contatoEmail) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ((_ctx.state.apresentarCampos))
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 1,
                                titulo: "ENDEREÇO"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_spin, {
                                    tip: "Consultando CEP...",
                                    spinning: _ctx.consultandoCep
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                          _createVNode(_component_a_form_item, { label: "CEP" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_campo_cep, {
                                                onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.consultaCep())),
                                                valor: _ctx.state.segurado.endereco.cep,
                                                "onUpdate:valor": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.segurado.endereco.cep) = $event))
                                              }, null, 8, ["valor"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.segurado.endereco.enderecoCompleto) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.segurado.endereco.enderecoCompleto]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                          _createVNode(_component_a_form_item, { label: "Número" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.segurado.endereco.numero) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.segurado.endereco.numero]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, [
                                          _createVNode(_component_a_form_item, { label: "Complemento" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.segurado.endereco.complemento) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.segurado.endereco.complemento]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_33, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Bairro",
                                            required: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.segurado.endereco.bairro) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.segurado.endereco.bairro]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_34, [
                                          _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_combo_cidade, {
                                                codigo: _ctx.state.segurado.endereco.codigoCidade,
                                                "onUpdate:codigo": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.segurado.endereco.codigoCidade) = $event))
                                              }, null, 8, ["codigo"])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createVNode(_component_a_form_item, { label: "Link Localização" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.segurado.endereco.localizacao) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.segurado.endereco.localizacao]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["spinning"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["spinning"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_comunicacao_api, {
        visivel: _ctx.appBase.exibirComunicaoApi,
        "onUpdate:visivel": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
        apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
        resposta: _ctx.appBase.resposta
      }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
    ]),
    _: 1
  }, 8, ["visible"]))
}